import React from "react";

import MainLayout from "components/MainLayout";
import MainList from "components/MainList";

import columns from "./columns";
import CreateVacationModal from "components/create_modals/CreateVacationModal";
import { useWorkers } from "context/providers/workers";

const VacationsList = () => {
  const { workers_list_options } = useWorkers();
  const columns_data = columns(workers_list_options);
  return (
    <MainLayout
      breadcrumbs={[{ name: "Urlopy" }]}
      buttons={<CreateVacationModal />}
    >
      <MainList
        columns={columns_data}
        query_name="vacations"
        query_path="/vacations"
        table_path="/vacations"
        query_context="index"
      />
    </MainLayout>
  );
};

export default VacationsList;
